export default __webpack_public_path__ + "static/media/thum1.5f3661ad.jpg";